import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PropriedadeSelecionadaPage } from './propriedade-selecionada.page';

const routes: Routes = [
  {
    path: '',
    component: PropriedadeSelecionadaPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PropriedadeSelecionadaPageRoutingModule {}
